export const POPULATE = 'ServiceHealthPopulate'

export const SET_LOADED = 'ServiceHealthSetLoaded'